import { render } from "./CartLikePriceDetail.vue?vue&type=template&id=2ba72949&scoped=true"
import script from "./CartLikePriceDetail.js?vue&type=script&lang=js"
export * from "./CartLikePriceDetail.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=2ba72949&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba72949"]])

export default __exports__